
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import global_en from './locales/en/index';
import global_es from './locales/es/index';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        interpolation: { escapeValue: false },
        load: 'languageOnly', // Forces 'es-MX' -> 'es', 'en-US' -> 'en' to fix strict checks
        debug: false,
        fallbackLng: 'en',
        resources: {
            en: {
                translation: global_en
            },
            es: {
                translation: global_es
            }
        }
    });

export default i18n;
